<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" @click="importFileB" type="success" plain v-if="!isMB">导入赠送金额</el-button>
        <el-button size="mini" class="filter-item" @click="importFile" type="success" plain v-if="!isMB">导入账户</el-button>
        <el-button size="mini" class="filter-item" @click="onExport" type="primary" plain v-if="!isMB">导出</el-button>
        <el-button size="mini" class="filter-item" type="primary" @click="toCreate">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <el-table-column
        slot="column"
        v-if="$permission.canWrite()"
        label="操作"
        fixed="right"
        align="center"
        width="90px"
      >
        <template slot-scope="{row}">
          <el-button type="text" @click="toEdit(row.AccountId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
          <el-button type="text" @click="editById(row.AccountId)" size="medium" icon="el-icon-refresh-left" title="退款"></el-button>
        </template>
      </el-table-column>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <create-dialog ref="createDialog" @close-saved="reload"></create-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
    <import-dialog-b ref="importDialogB" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/account/list";
import editDialog from "@/components/consume/account/editDialog";
import createDialog from "@/components/consume/account/createDialog";
import importDialog from "@/components/consume/account/importDialog";
import importDialogB from "@/components/consume/account/importDialogB";

export default {
  name: "account",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    createDialog,
    importDialogB
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/consume/account").default,
    }
  },
  methods: {
    toCreate() {
      this.$refs.createDialog.openCreate();
    },
    toEdit(id) {
      this.$refs.createDialog.openEditById(id);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.AccountId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    refund() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要退款的记录");
        return;
      }
      this.$confirm("确认进行退款吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.AccountId;
          });
          // this.api.refund(ids).then(res => {
          //   if(res.Code==0) {
          //     this.$message.success("退款成功")
          //     this.reload();
          //   } else {
          //     this.$message.error(res.Msg);
          //   }
          // })
        })
        .catch(() => {});
    },
    onExport() {
      this.$refs.list.export();
    },
    importFile() {
      this.$refs.importDialog.open();
    },
    importFileB() {
      this.$refs.importDialogB.open();
    },
  },
};
</script>